import styled from "@emotion/styled";

type AlignOptions =
    | "normal"
    | "stretch"
    | "center"
    | "start"
    | "end"
    | "flex-start"
    | "flex-end"
    | "self-start"
    | "self-end"
    | "baseline"
    | "first baseline"
    | "last baseline"
    | "safe center"
    | "unsafe center";

type JustifyContentOptions =
    | "center"
    | "start"
    | "end"
    | "flex-start"
    | "flex-end"
    | "left"
    | "right"
    | "space-between"
    | "space-around"
    | "space-evenly"
    | "stretch"
    | "safe center"
    | "unsafe center";

export interface FlexboxProps {
    flex?: string;
    flexShrink?: number;
    flexDirection?: "row" | "row-reverse" | "column" | "column-reverse";
    alignItems?: AlignOptions;
    justifyContent?: JustifyContentOptions;
}

export const Flexbox = styled("div")<FlexboxProps>`
    display: flex;
    flex: ${({ flex }) => flex};
    flex-direction: ${({ flexDirection }) => flexDirection};
    flex-shrink: ${({ flexShrink }) => flexShrink};
    align-items: ${({ alignItems }) => alignItems};
    justify-content: ${({ justifyContent }) => justifyContent};
`;
